<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)

    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="flex flex-wrap">
      <div class="w-full md:w-3/5">
        <div class="m-2 px-0 md:mr-6 mb-16">
          <PlannerHeader id="knowledge-header" :hide-add="true" class="mb-4">growth academy</PlannerHeader>
          <div v-if="academyOpen">
            <Lesson v-for="lesson in lessons" :lesson="lesson" :key="lesson.id" @showPopup="(enhancedLesson) => setLesson(enhancedLesson)" />
          </div>
          <AcademyTeaser v-else/>
        </div>
      </div>
      <div class="w-full md:w-2/5 px-0 ">
        <div class="m-2">
           <Quick/>
        </div>

<!--          <vx-card>
          asdasd
        </vx-card> -->
      </div>

      <LessonPopup :lesson="popupLesson" :showPopup="showPopup" @popupHidden="showPopup=false" />
    </div>

</template>

<script>
import AcademyTeaser from './AcademyTeaser.vue'
import Quick from './Quick.vue'
import LessonPopup from './LessonPopup.vue'
import Lesson from './Lesson.vue'
import _ from 'lodash'
// import moduleEmail         from '@/store/email/moduleEmail.js'

export default {
  components: {
    AcademyTeaser,
    Quick,
    Lesson,
    LessonPopup
  },
  data () {
    return {
      popupLesson: null,
      showPopup: false
    }
  },
  watch: {
  },
  computed: {
    lessons () {
      return  _.sortBy(this.userLessons, 'order')
    },
    academyOpen () {
      return this.$store.getters.academyRequested
    },
    userLessons () {
      return this.$store.getters.userLessons
    }
  },
  methods: {
    setLesson (enhancedLesson) {
      this.popupLesson = enhancedLesson
      this.showPopup = true
    }
  },
  mounted () {
    this.notifier.visitKnowledgePage(this.$store)
  }
}

</script>

<style lang="scss">

.lesson {
  .vx-card__header {
    padding: 0.3rem !important
  }
}

.wizard-btn {
  min-width: 100px !important
}
</style>
